Librarian.Lang = { };
Librarian.Lang.strings = { };

Librarian.Lang.loadLangScripts = function() {
    var head = document.getElementsByTagName("head")[0];

    // Load each of the available langauges, first from
    // the and then from each library.
    // This allows the core to set up the default values
    // before the libraries override them.
    for (var i = 0; i < Librarian.lang.availableLangs.length; i++) {
        var script = document.createElement("script");
        script.src = Librarian.path.getLayoutsPath() + "core/lang/" + Librarian.lang.availableLangs[i] + ".js?" + Librarian.buildVersion;
        script.charset = "utf-8";
        script.type = "text/javascript";
        head.appendChild(script);
    }

    window.addEvent("logonUser", function(){
        for (var i = 0; i < Librarian.lang.availableLangs.length; i++) {
            script = document.createElement("script");
            script.src = Librarian.path.getLibraryPath() + "lang/" + Librarian.lang.availableLangs[i] + ".js?" + Librarian.buildVersion;
            script.charset = "utf-8";
            script.type = "text/javascript";
            head.appendChild(script);
        }
    });
};

Librarian.Lang.addLang = function(lang, strings) {
    // If this language doesn't exist yet, create it
    var langList = Librarian.Lang.strings[lang];
    if ((typeof langList == "undefined") || (langList == null))
        Librarian.Lang.strings[lang] = { };

    // Set all the strings for this language, but don't overwrite
    // any if they exist already
    Librarian.Lang.setLangStrings(lang, strings, false);
};

Librarian.Lang.updateLang = function(lang, strings) {
    // If this language doesn't exist yet, add it
    var langList = Librarian.Lang.strings[lang];
    if ((typeof langList == "undefined") || (langList == null)) {
        Librarian.Lang.addLang(lang, strings);
        return;
    }

    // Set all the strings for this language, and overwrite
    // any if they exist already
    Librarian.Lang.setLangStrings(lang, strings, true);
};

Librarian.Lang.setLangStrings = function(lang, strings, overwrite) {
    // Copy each key individually so they
    // are added and updated rather than replacing
    // the entire collection.
    // This allows for selective updates rather than
    // requiring the entire list of strings to be present in
    // each Library's localization override.
    // Only overwrite strings that exist if we are told to
    for (var key in strings) {
        var currentValue = Librarian.Lang.strings[lang][key];
        if (overwrite || (typeof currentValue == "undefined") || (currentValue == null))
            Librarian.Lang.strings[lang][key] = strings[key];
    }
};

Librarian.Lang.getString = function(name, preservePlurals) {
    var string = null;
    // Get the string for the current language and given name
    if (Librarian.Lang.strings[Librarian.lang.currentLang])
        string = Librarian.Lang.strings[Librarian.lang.currentLang][name];

    // If the string doesn't exist with the current langauge, get the
    // string from the default language instead.
    if (((typeof string == "undefined") || (string == null)) && Librarian.Lang.strings[Librarian.lang.defaultLang])
        string = Librarian.Lang.strings[Librarian.lang.defaultLang][name];

    string = string || name || '';
    // Remove all plural tokens if we're not using them
    if (preservePlurals !== true)
        return string.replaceAll("{plural}", '');
    return string;
};

Librarian.Lang.getArgString = function(name, args, preservePlurals) {
    var string = Librarian.Lang.getString(name, preservePlurals);

    args = Array.from(args);

    // Loop through each argument
    for (var i = 0; i < args.length; i++) {
        var token = '{' + i + '}',
            arg = args[i];
        // Save and validate the argument here rather than using the || '' method
        // because doing that makes booleans and the number 0 not show up, as they evaluate to false
        if ((typeof arg == "undefined") || (arg == null))
            arg = '';

        // And replace all instances of the token referencing
        // this argument index
        string = string.replaceAll(token, arg.toString());
    }

    return string;
};

Librarian.Lang.getPluralString = function(name, count) {
    return Librarian.Lang.pluralizeString(Librarian.Lang.getString(name, true), count);
};

Librarian.Lang.getPluralArgString = function(name, count, args) {
    return Librarian.Lang.pluralizeString(Librarian.Lang.getArgString(name, args, true), count);
};

Librarian.Lang.pluralizeString = function(string, count) {
    // Find the initial token location
    var index = string.indexOf("{plural}");

    // Replace each instance of the plural token
    while (index >= 0) {
        // Get the index of the last space before the plural token and add 1
        // to not include that in the substring
        var spaceindex = string.substring(0, index).lastIndexOf(' ') + 1;
        // The word is whatever's in between that space location and the plural location
        var word = string.substring(spaceindex, index);
        // Save the casing of the word
        var isUpper = word.isUpperCase();

        // Pluralize the word using the library, if it's there
        if (typeof owl != "undefined")
            word = owl.pluralize(word, count);

        // If the word used to be uppercase, make the plural word uppercase too
        if (isUpper)
            word = word.toUpperCase();

        // Replace the word and the plural token with the plural version of the word
        string = string.replace(/\w+{plural}/, word);

        // Find the new token location
        index = string.indexOf("{plural}");
    }

    return string;
};

Librarian.Lang.getStorageKey = function() {
    var shortName = Librarian.sessionInfo.ShortName;

    return shortName + "-lang";
};

Librarian.Lang.saveLanguage = function() {
    if (!localStorage)
        return;

    var key = Librarian.Lang.getStorageKey();
    localStorage.setItem(key, Librarian.lang.currentLang);
};

Librarian.Lang.loadSavedLanguage = function() {
    if (!localStorage)
        return;

    var key = Librarian.Lang.getStorageKey();
    var lang = localStorage.getItem(key);

    if (lang)
        Librarian.Lang.setLang(lang);
};

Librarian.Lang.setLang = function(lang) {
    Librarian.lang.currentLang = lang;
    Librarian.Lang.saveLanguage();

    Librarian.Lang.translateElements();
}

Librarian.Lang.translateElements = function(parent) {
    if (!parent)
        parent = $(document.body);

    var elements = parent.getElements("[data-translation]");
    
    elements.forEach(function(el) {
        var translation = el.get("data-translation");
        var text = Librarian.Lang.getString(translation);
        if (!text)
            return;

        if (el.get("tag") == "input")
            el.set("value", text);
        else
            el.set("text", text);
    });
}

Librarian.Lang.loadLangScripts();